import { buildLink, KitchenSinkRoute, RouteSlotInput } from '@luks/ui';

import { buildDrupalImage } from "../Image";

export function mapParagraphLogoCloud(
  input: ParagraphLogoCloudFragment,
): RouteSlotInput<typeof KitchenSinkRoute, 'body', 'LogoCloud'> {
  return {
    key: 'LogoCloud',
    input: {
      logos: input.logoImages?.map((item) => ({
        Image: item?.image
          ? buildDrupalImage(item.image, 'teaser')
          : undefined,
        Link: item?.link?.url
          ? buildLink({ href: item.link.url })
          : undefined,
      })),
    },
  };
}
